module.exports = __webpack_public_path__ + "static/logo-white-8e0e91835d4bbe6cac5ac782d52bfe22.png";